import { slice } from './slice'

const settingsActions = {
  ...slice.actions,
}

export default settingsActions
